@if (isInputField()) {
    @if (isInputFieldCheckbox()) {
        <sag-ui-checkbox class="[&>div]:h-[66px]" [required]="field().required" [formControl]="control()">
            {{ field().label | translate }}
        </sag-ui-checkbox>
    } @else {
        <sag-ui-input
            [label]="field().label | translate"
            [required]="field().required"
            [invalid]="control().invalid && control().touched"
            [placeholder]="field().placeholder || '' | translate"
            [hint]="field().hint || '' | translate"
            [formControl]="isNumericField() ? numericDisplayControl : control()"
            [type]="inputType()"
            [attr.inputmode]="isNumericField() ? 'decimal' : null"
            [error]="
                control().errors
                    | controlErrorHandler: control().touched
                    | translate: (control().errors | controlErrorParams: control().touched)
            "
            (blur)="control().markAsTouched()"
        ></sag-ui-input>
    }
}

@if (isSelectField()) {
    <sag-ui-select
        [label]="field().label | translate"
        [required]="field().required"
        [invalid]="control().invalid && control().touched"
        [placeholder]="field().placeholder || '' | translate"
        [formControl]="control()"
        [multiple]="field().isMultiSelect"
        [search]="field().isMultiSelect || selectOptions().length > 10"
        [error]="
            control().errors
                | controlErrorHandler: control().touched
                | translate: (control().errors | controlErrorParams: control().touched)
        "
        (blur)="control().markAsTouched()"
    >
        @if (field().name | isFieldLoading) {
            <sag-ui-option><app-loading-indicator></app-loading-indicator></sag-ui-option>
        }
        @for (option of selectOptions(); track option) {
            <sag-ui-option [value]="option">{{ option | translate }}</sag-ui-option>
        }
    </sag-ui-select>
}

@if (isDateRangeField()) {
    <sag-ui-input
        [label]="field().label | translate"
        [required]="field().required"
        [invalid]="control().invalid && control().touched"
        [placeholder]="field().placeholder || '' | translate"
        [dateFormat]="'yyyy-MM-dd'"
        [hint]="field().hint || '' | translate"
        [formControl]="control()"
        type="date"
        [error]="
            control().errors
                | controlErrorHandler: control().touched
                | translate: (control().errors | controlErrorParams: control().touched)
        "
        (blur)="control().markAsTouched()"
    >
    </sag-ui-input>
}

@if (isRoleField() && !isEntraIdGroupMembersLoading()) {
    <sag-ui-autocomplete
        [label]="field().label | translate"
        [invalid]="control().invalid && control().touched"
        [required]="field().required"
        [placeholder]="field().placeholder || '' | translate"
        [formControl]="control()"
        [hint]="field().hint || '' | translate"
        [error]="
            control().errors
                | controlErrorHandler: control().touched
                | translate: (control().errors | controlErrorParams: control().touched)
        "
        [attr.data-invalid]="control().invalid && control().touched"
        (blur)="control().markAsTouched()"
    >
        @if (!isRequiredRoleField()) {
            <sag-ui-autocomplete-option [value]="participantNotRequired" [selected]="' ' === control().value">{{
                'workflow-field.not-required' | translate
            }}</sag-ui-autocomplete-option>
        }
        @for (entraIdGroupMember of entraIdGroupMembers(); track entraIdGroupMember.id) {
            <sag-ui-autocomplete-option
                [value]="entraIdGroupMember.id"
                [selected]="entraIdGroupMember.id === control().value"
                >{{ entraIdGroupMember.displayName }}</sag-ui-autocomplete-option
            >
        }
    </sag-ui-autocomplete>
}
